import { inject } from '@angular/core';
import { AdministrationApiConfiguration } from '../../api/administration/administration-api-configuration';
import { IdentityApiConfiguration } from '../../api/identity/identity-api-configuration';
import { SchedulerApiConfiguration } from '../../api/scheduler/scheduler-api-configuration';
import { RuntimeConfigService } from '../services/runtime-config.service';

export interface ApiClientConfigs {
  identity: IdentityApiConfiguration;
  administration: AdministrationApiConfiguration;
  scheduler: SchedulerApiConfiguration;
}

/**
 * Resolves the generated client configuration singletons. Must be called
 * synchronously inside an injection context (the `inject()` calls cannot run
 * after an `await`).
 */
export function injectApiClientConfigs(): ApiClientConfigs {
  return {
    identity: inject(IdentityApiConfiguration),
    administration: inject(AdministrationApiConfiguration),
    scheduler: inject(SchedulerApiConfiguration),
  };
}

/**
 * Applies the loaded runtime API URLs to the generated client configurations.
 * Called after `RuntimeConfigService.load()` resolves.
 */
export function configureApiClients(
  runtime: RuntimeConfigService,
  configs: ApiClientConfigs
): void {
  configs.identity.rootUrl = withRootUrl(runtime.identity);
  configs.administration.rootUrl = withRootUrl(runtime.backend);
  configs.scheduler.rootUrl = withRootUrl(runtime.backend);
}

function withRootUrl(url: string): string {
  return url.replace(/\/+$/, '');
}
